<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Notifications" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-gradient-danger"
                      @click="$router.push({ name: 'dashboard-overview' })"
                  >
                    <span class="text-nowrap">Back To Dashboard</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
                       url="v1/notifications"
                       :filteredData="[]"
                       :tableHeaderValues="tableHeaderValues"
                       :actions="[]"
                       :mutedData="[]"
                       customClass="table-hover-animation"
                       :loadMore="true"
                       :hidePerPage="true"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {
  mounted() {
    this.getNotifications()
  },
  data() {
    return {
      notificationList:[],
      tableHeaderValues: [
        {
          title: 'Type',
          valueKey: 'type',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          },
          cta: (row) => {
            this.$router.push({name:'transactions'})
          }
        },
        {
          title: 'Message',
          valueKey: 'message',
        },
        {
          title: 'Created',
          valueKey: 'created_at',
       alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: []
    }
  },
  methods: {
    getNotifications() {
      this.makeRequest('post', 'v1/notifications', {}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.notificationList = data.data
          }
        }

      });

    },
  },
}
</script>

